import { render, staticRenderFns } from "./FormDistrictAdd.vue?vue&type=template&id=7b9c3c51"
import script from "./FormDistrictAdd.vue?vue&type=script&lang=js"
export * from "./FormDistrictAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports